module.exports = __webpack_public_path__ + "media/choosing_a_college/choosing-a-college_header-m-afcc4537.png";